import React, {useCallback, useState} from 'react';
import { connect } from "react-redux";
import {
    setArrangementBottomResizing,
    setArrangementBottomHeight,
       } from 'actions/index.js';
import {PIANO_ROLL, MODE_TO_HEIGHT} from 'constants/arrangement-modes.js';
const DOUBLE_CLICK_TIME = 300;
const MIN_HEIGHT = 50;

function ArrangementBottomResizer(props) {
    const [lastClick, setLastClick] = useState(undefined);
    const onMouseDown = useCallback((e) => {
        props.setArrangementBottomResizing(true);
        let now = new Date().getTime();
        if (lastClick !== undefined) {
            if (now - lastClick <= DOUBLE_CLICK_TIME) {
                if (props.sequencerEngine.store.getState().arrangement.bottomHeight <= MIN_HEIGHT) {
                    props.setArrangementBottomHeight(MODE_TO_HEIGHT[PIANO_ROLL]);
                } else {
                    props.setArrangementBottomHeight(0);
                }
            }
        }
        setLastClick(now);
    }, [lastClick, setLastClick]);

    return (
        <div
          onMouseDown={onMouseDown}
          className="arrangement-resizing-edge">
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        setArrangementBottomResizing: (resizing) =>
            dispatch(setArrangementBottomResizing(resizing)),
        setArrangementBottomHeight: (height) =>
            dispatch(setArrangementBottomHeight(height))
    };
};
 
export default connect(null, mapDispatchToProps)(ArrangementBottomResizer);
